module.exports = __webpack_public_path__ + "img/eat1stlogo.c7fe64d9.png";